import { useMemo } from 'react';
import { findChildByName } from 'widgets/statspro/js/components/common/utils/find-children-by-name';

/**
 * Custom hook to extract specific child components by name
 *
 * @param {any} children - The children to search through.
 * @returns {object} Object containing extracted child components.
 */
export const useChildComponentExtractor = (children) => {
    return useMemo(
        () => ({
            navItems: findChildByName(children, 'StatsSectionNavItems'),
            filterItems: findChildByName(
                children,
                'StatsSectionNavFilterItems'
            ),
            additionalNavItems: findChildByName(
                children,
                'StatsSectionAdditionalNavItems'
            ),
            roundButtons: findChildByName(children, 'StatsSectionRoundButtons'),
            settingsButton: findChildByName(
                children,
                'StatsSectionSettingsButton'
            ),
            searchBarMobile: findChildByName(
                children,
                'StatsSectionSearchMobile'
            ),
            responsiveRowItems: findChildByName(
                children,
                'StatsSectionResponsiveRowItems'
            )
        }),
        [children]
    );
};
